import ChangePassword from '../../../changePassword'

export default {
  ChangePassword
}



// WEBPACK FOOTER //
// ./src/layout/headers/menu/user/resources/components.js